@if (form) {
  <div class="form p-4" [formGroup]="form">
    <div class="flex flex-column gap-2 mb-3">
      <label for="photoType" class="font-semibold w-full"
        >{{ "gate_administration.file_upload_form.photo_type" | translate }}*</label
      >
      <p-select
        appendTo="body"
        id="photoType"
        formControlName="photoType"
        [options]="photoTypes"
        [style]="{ width: '100%' }"
      />
    </div>
    @if (form.get("photoType")?.value === "other") {
      <div class="flex flex-column gap-2 mb-3">
        <label for="label" class="font-semibold w-full"
          >{{ "gate_administration.file_upload_form.label" | translate }} *</label
        >
        <input pInputText id="label" formControlName="label" autocomplete="off" />
      </div>
    }
    <div class="flex justify-content-between align-items-center mb-3">
      @if (image && image.link) {
        <a [href]="image.link" class="linkPrimaryColor" target="_blank">{{
          "gate_administration.file_upload_form.open_image" | translate
        }}</a>
      }
      <p-fileUpload
        [showUploadButton]="false"
        [showCancelButton]="false"
        styleClass="customFileUpload"
        class="w-full"
        [chooseLabel]="translate.instant('gate_administration.file_upload_form.choose_image')"
        (onSelect)="onFileSelect($event)"
        accept="image/*"
      >
        <ng-template #content let-uploadedFiles>
          @if (uploadedFiles.length > 0) {
            {{ uploadedFiles.length }}
            {{ "common.files_selected" | translate }}
          }
        </ng-template>
      </p-fileUpload>
    </div>
    <!-- Buttons: -->
    <div class="flex justify-content-end gap-2 dialogBtnGroup">
      <app-button
        id="closeFileDialog"
        [buttonText]="translate.instant('common.cancel')"
        (click)="closeDialog()"
      ></app-button>
      <app-button
        id="saveFileButton"
        [buttonText]="translate.instant('common.save')"
        [disabled]="!form.valid"
        (click)="save()"
      ></app-button>
    </div>
  </div>
}
